import classnames from 'classnames';
import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  default: ({ color, isActive, isDisabled, isFilled, isLoading }) => {
    const colour = color ? color : COLORS.BLUE;
    return {
      thRoot: classnames(
        'border-1 flex items-stretch leading-none rounded-tiny text-base transition-colors',
        {
          [`bg-white border-gray-light text-gray-darker focus-within:border-${colour} hover:border-${colour} focus-within:text-${colour} hover:text-${colour}`]:
            !isActive && !isFilled && !isDisabled,
          [`bg-white border-${colour} text-${colour}`]: isActive && !isFilled && !isDisabled,
          [`bg-${colour} border-${colour} text-white`]: isFilled && !isDisabled,
          'bg-gray-lighter border-gray-light text-gray-medium': isDisabled,
        },
      ),
      thHeightStyle: {
        minHeight: '3.125rem',
        // IE11 needs a height in addition to minHeight to center vertically.
        height: '1px',
      },
      thButton: classnames(
        'reset-button flex items-center flex-1 text-current text-initial justify-center',
        {
          'lg:justify-between': !isLoading,
        },
      ),
      thClear: 'reset-button px-3 flex-shrink-0 text-current',
      thClearSize: '0.625rem',
      thIcon: 'flex-shrink-0 md:ml-2',
      thIconSelect: `hidden lg:inline-block md:flex-shrink-0 mx-2 transition-transform ${
        isActive ? 'rotate-180' : ''
      }`,
      thLoader: 'flex items-center justify-center leading-none',
      thSpinnerColor: isFilled ? 'current' : 'blue',
    };
  },
  search: ({ color, isActive, isDisabled, isFilled }) => {
    const colour = color ? color : COLORS.BLUE;
    return {
      thRoot: classnames(
        'border-1 flex items-stretch leading-none rounded-tiny text-base transition-colors',
        {
          [`bg-white border-gray-medium text-gray-darker focus-within:border-${colour} hover:border-${colour} focus-within:text-${colour} hover:text-${colour}`]:
            !isActive && !isFilled && !isDisabled,
          [`bg-white border-${colour} text-${colour}`]: isActive && !isFilled && !isDisabled,
          [`bg-${colour} border-${colour} text-white`]: isFilled && !isDisabled,
          'bg-gray-lighter border-gray-light text-gray-medium': isDisabled,
        },
      ),
      thHeightStyle: {
        height: '1px',
      },
      thButton: classnames(
        'reset-button flex items-center flex-1 text-current text-initial button-default lg:justify-between justify-center',
      ),
      thClear: 'reset-button px-3 flex-shrink-0 text-current',
      thClearSize: '0.625rem',
      thIcon: 'flex-shrink-0 lg:mx-3',
      thIconSelect: `hidden lg:inline-block lg:flex-shrink-0 mx-3 transition-transform ${
        isActive ? 'rotate-180' : ''
      }`,
      thLoader: 'flex items-center justify-center leading-none',
      thSpinnerColor: isFilled ? 'current' : 'blue',
    };
  },
};
